
<template>
  <div class="router_view">
    <router-view v-slot="{ Component, route }">
      <component :key="route.name" :is="Component" />
    </router-view>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
// import { store } from '@/pinia/store'
import { useAppStore } from '@/stores/modules/app'
import { currentDev } from './config/env';
import { debounce } from 'lodash-es';

// import useSettingStore from '@/stores/modules/setting'
// import { ScreenEnum } from './enums/appEnums'
// import { useDark, useWindowSize, useThrottleFn } from '@vueuse/core'

const storeData = useAppStore()
// const settingStore = useSettingStore()
// const elConfig = {
//     zIndex: 3000,
// }
// const isDark = useDark()

onMounted(async () => {
  await pcAdminInfoInit()
    //   //设置主题色
    //   settingStore.setTheme(isDark.value)
    // // 获取配置
  // const data: any = await storeData.getConfig()
  // 防抖处理ResizeObserver
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      // 使用更合理的防抖时间（30ms）
      const debouncedCallback = debounce(function(entries, observer) {
        // 使用 requestAnimationFrame 确保在下一帧执行
        requestAnimationFrame(() => {
          if (!entries || !observer || !callback) return        
          const validEntries = entries.filter(entry => {
            try {
              return entry.target && document.contains(entry.target)
            } catch (error) {
              return false
            }
          })
          if (validEntries.length > 0) {
            try {
              callback(validEntries, observer)
            } catch (error) {
              console.error('ResizeObserver回调执行失败:', error)
            }
          }
        })
      }, 30);
      
      super(debouncedCallback);
    }
  };
})

// const { width } = useWindowSize()
const pcAdminInfoInit = async () => {
  // 控制台模式下，初始化appData
  try {
    const meta = {
      os: 7, //公众号
      lang: 'zh-CN',
    }
    // const cid = await utilGetFpPromise()
    const cid = localStorage.getItem('visitorId') || 'ce0071a2b1529904b1125397d3164784'
    storeData.headerInfo['c-id'] = `w-${cid}`
    storeData.headerInfo['c-meta'] = JSON.stringify(meta)
    const rpcParam = {
      'cid': `w-${cid}`,
      'cmeta': meta
    }
    localStorage.setItem('rpcParam', JSON.stringify(rpcParam))
  } catch (error) {
    console.log('pcAdminInfoInit失败', error)
  }
  localStorage.setItem('appBaseUrl', import.meta.env.BASE_URL)
  localStorage.setItem('envMode', String(currentDev))
  console.log(currentDev, '***')
}
// watch(
//     width,
//     useThrottleFn((value) => {
//         if (value > ScreenEnum.SM) {
//           storeData.setMobile(false)
//           storeData.toggleCollapsed(false)
//         } else {
//           storeData.setMobile(true)
//           storeData.toggleCollapsed(true)
//         }
//         if (value < ScreenEnum.MD) {
//           storeData.toggleCollapsed(true)
//         }
//     }),
//     {
//         immediate: true
//     }
// )
</script>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
<style lang="scss">
@import '@/styles/index.scss';
</style>
